var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"todo-container"}},[_vm._m(0),_c('ComingSoonBanner')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',{staticClass:"fad fa-fw fa-list"}),_vm._v(" To Do")])}]

export { render, staticRenderFns }